import { PopulatedResource, RESOURCE_TYPE, ROLE_FILTER } from "./LibraryModels";
import {
  ANSWER_TYPE,
  CORE,
  Category,
  IQuestion,
  LANGUAGE_TRANSLATION,
  QUESTION_ACTOR,
  QUESTION_TYPE,
} from "./SurveyModels";

export enum SeverityImage {
  CHAMPION = "champion",
  CRITICAL = "critical",
}

export interface IssuePayload {
  questions: IQuestion[];

  categoryId: string;
  severity: SEVERITY;
  translations: {
    language: LANGUAGE_TRANSLATION | string;
    title: string;
    description: string;
  }[];
  resourceId?: PopulatedResource;
  role: ROLE_FILTER;
}

export interface PopulatedIssue {
  id: string;
  questions: IQuestion[];
  categoryId?: string;
  description: string;
  title: string;
  category: Category;
  severity: SEVERITY;
  translations: {
    language: LANGUAGE_TRANSLATION | string;
    title: string;
    description: string;
  }[];
  resourceId?: PopulatedResource;
  createdAt: string;
  enabled: boolean;
  role: ROLE_FILTER;
}

export enum SEVERITY {
  CRITICAL = "critical",
  CHAMPION = "champion",
}

export const severity: { [key: string]: string }[] = Object.keys(SEVERITY).map(
  (key) => ({
    [key]: SEVERITY[key as keyof typeof SEVERITY],
  })
);
export const issueModel = {
  translations: [
    {
      language: "",
      title: "",
      description: "",
    },
  ],
};

/* export const issuesArray: PopulatedIssue[] = [
  {
    severity: SEVERITY.CHAMPION,
    enabled: false,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ITALIAN,
        title: "Qual'è la capitale della Francia?",
        description: "sadjnasdjkasndlkd",
      },
      {
        language: LANGUAGE_TRANSLATION.GERMAN,
        title: "Che giorno è?",
        description: "jkndfjsandsaskmd",
      },
    ],
    createdAt: "2023-06-06T08:02:16.230Z",
    resourceId: {
      category: {
        background: "rgba(65, 195, 215, 0.1)",
        icon: "icon-person",
        description:
          "Il livello di responsabilità delle azioni lavorativi e la capacità di prendere decisioni",
        id: "9d2d0db0-12b1-4cae-a6ef-e8edfdaba5f1",
        name: "Accountability",
        coreArea: CORE.O,
        color: "#41C3D7",
      },
      id: "string",
      translations: [
        {
          language: LANGUAGE_TRANSLATION.ITALIAN,
          title: "string",
          description: "string",
          link: "string",
        },
      ],
      type: RESOURCE_TYPE.ELEARNING,
      roles: [ROLE_FILTER.HR],
      enabled: true,
      createdAt: "2023-06-06T08:02:16.230Z",
    },
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.FREE_TEXT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ITALIAN,
            text: "Qual'è la capitale della Francia?",
          },
          {
            language: LANGUAGE_TRANSLATION.GERMAN,
            text: "Che giorno è?",
          },
        ],
        createdAt: "2023-06-06T08:02:16.230Z",
        id: "bcd82d61-34b4-493f-9860-c379fd6b361b",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(65, 195, 215, 0.1)",
            icon: "icon-person",
            description:
              "Il livello di responsabilità delle azioni lavorativi e la capacità di prendere decisioni",
            id: "9d2d0db0-12b1-4cae-a6ef-e8edfdaba5f1",
            name: "Accountability",
            coreArea: CORE.O,
            color: "#41C3D7",
          },
        ],
        templates: [],
      },
    ],
    id: "de510d13-8459-422d-a0cc-4d67dd8af4ee",
    category: {
      background: "rgba(65, 195, 215, 0.1)",
      icon: "icon-trending-up",
      description:
        "Il livello di proattività e la qualità della visione strategica",
      id: "1be5ccc0-61a1-4054-aae2-9ce17879aa41",
      name: "Autoimprenditorialità",
      coreArea: CORE.O,
      color: "#41C3D7",
    },
  },
  {
    severity: SEVERITY.CRITICAL,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
  {
    severity: SEVERITY.CHAMPION,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
  {
    severity: SEVERITY.CRITICAL,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
  {
    severity: SEVERITY.CHAMPION,
    enabled: false,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ITALIAN,
        title: "Qual'è la capitale della Francia?",
        description: "sadjnasdjkasndlkd",
      },
      {
        language: LANGUAGE_TRANSLATION.GERMAN,
        title: "Che giorno è?",
        description: "jkndfjsandsaskmd",
      },
    ],
    createdAt: "2023-06-06T08:02:16.230Z",
    resource: {
      category: {
        background: "rgba(65, 195, 215, 0.1)",
        icon: "icon-person",
        description:
          "Il livello di responsabilità delle azioni lavorativi e la capacità di prendere decisioni",
        id: "9d2d0db0-12b1-4cae-a6ef-e8edfdaba5f1",
        name: "Accountability",
        coreArea: CORE.O,
        color: "#41C3D7",
      },
      id: "string",
      translations: [
        {
          language: LANGUAGE_TRANSLATION.ITALIAN,
          title: "string",
          description: "string",
          link: "string",
        },
      ],
      type: RESOURCE_TYPE.ELEARNING,

      roles: [ROLE_FILTER.HR],
      enabled: true,
      createdAt: "2023-06-06T08:02:16.230Z",
    },
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.FREE_TEXT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ITALIAN,
            text: "Qual'è la capitale della Francia?",
          },
          {
            language: LANGUAGE_TRANSLATION.GERMAN,
            text: "Che giorno è?",
          },
        ],
        createdAt: "2023-06-06T08:02:16.230Z",
        id: "bcd82d61-34b4-493f-9860-c379fd6b361b",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(65, 195, 215, 0.1)",
            icon: "icon-person",
            description:
              "Il livello di responsabilità delle azioni lavorativi e la capacità di prendere decisioni",
            id: "9d2d0db0-12b1-4cae-a6ef-e8edfdaba5f1",
            name: "Accountability",
            coreArea: CORE.O,
            color: "#41C3D7",
          },
        ],
        templates: [],
      },
    ],
    id: "de510d13-8459-422d-a0cc-4d67dd8af4ee",
    category: {
      background: "rgba(65, 195, 215, 0.1)",
      icon: "icon-trending-up",
      description:
        "Il livello di proattività e la qualità della visione strategica",
      id: "1be5ccc0-61a1-4054-aae2-9ce17879aa41",
      name: "Autoimprenditorialità",
      coreArea: CORE.O,
      color: "#41C3D7",
    },
  },
  {
    severity: SEVERITY.CRITICAL,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
  {
    severity: SEVERITY.CHAMPION,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
  {
    severity: SEVERITY.CRITICAL,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
  {
    severity: SEVERITY.CHAMPION,
    enabled: false,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ITALIAN,
        title: "Qual'è la capitale della Francia?",
        description: "sadjnasdjkasndlkd",
      },
      {
        language: LANGUAGE_TRANSLATION.GERMAN,
        title: "Che giorno è?",
        description: "jkndfjsandsaskmd",
      },
    ],
    createdAt: "2023-06-06T08:02:16.230Z",
    resource: {
      category: {
        background: "rgba(65, 195, 215, 0.1)",
        icon: "icon-person",
        description:
          "Il livello di responsabilità delle azioni lavorativi e la capacità di prendere decisioni",
        id: "9d2d0db0-12b1-4cae-a6ef-e8edfdaba5f1",
        name: "Accountability",
        coreArea: CORE.O,
        color: "#41C3D7",
      },
      id: "string",
      translations: [
        {
          language: LANGUAGE_TRANSLATION.ITALIAN,
          title: "string",
          description: "string",
          link: "string",
        },
      ],
      type: RESOURCE_TYPE.ELEARNING,

      roles: [ROLE_FILTER.HR],
      enabled: true,
      createdAt: "2023-06-06T08:02:16.230Z",
    },
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.FREE_TEXT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ITALIAN,
            text: "Qual'è la capitale della Francia?",
          },
          {
            language: LANGUAGE_TRANSLATION.GERMAN,
            text: "Che giorno è?",
          },
        ],
        createdAt: "2023-06-06T08:02:16.230Z",
        id: "bcd82d61-34b4-493f-9860-c379fd6b361b",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(65, 195, 215, 0.1)",
            icon: "icon-person",
            description:
              "Il livello di responsabilità delle azioni lavorativi e la capacità di prendere decisioni",
            id: "9d2d0db0-12b1-4cae-a6ef-e8edfdaba5f1",
            name: "Accountability",
            coreArea: CORE.O,
            color: "#41C3D7",
          },
        ],
        templates: [],
      },
    ],
    id: "de510d13-8459-422d-a0cc-4d67dd8af4ee",
    category: {
      background: "rgba(65, 195, 215, 0.1)",
      icon: "icon-trending-up",
      description:
        "Il livello di proattività e la qualità della visione strategica",
      id: "1be5ccc0-61a1-4054-aae2-9ce17879aa41",
      name: "Autoimprenditorialità",
      coreArea: CORE.O,
      color: "#41C3D7",
    },
  },
  {
    severity: SEVERITY.CRITICAL,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
  {
    severity: SEVERITY.CHAMPION,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
  {
    severity: SEVERITY.CRITICAL,
    enabled: true,
    translations: [
      {
        language: LANGUAGE_TRANSLATION.ENGLISH,
        title: "What is the capital of Germany?",
        description: "Question about geography",
      },
      {
        language: LANGUAGE_TRANSLATION.SPANISH,
        title: "¿Cuál es la capital de España?",
        description: "Pregunta sobre geografía",
      },
    ],
    createdAt: "2023-06-07T10:30:00.000Z",
    question: [
      {
        enabled: true,
        answerMode: ANSWER_TYPE.LIKERT,
        translations: [
          {
            language: LANGUAGE_TRANSLATION.ENGLISH,
            text: "Rate your satisfaction with the training program.",
          },
          {
            language: LANGUAGE_TRANSLATION.SPANISH,
            text: "Evalúa tu satisfacción con el programa de capacitación.",
          },
        ],
        createdAt: "2023-06-07T10:30:00.000Z",
        id: "12345678",
        actor: QUESTION_ACTOR.HR,
        self: true,
        type: QUESTION_TYPE.STANDARD,
        categories: [
          {
            background: "rgba(255, 187, 0, 0.1)",
            icon: "icon-graduation-cap",
            description: "Training Satisfaction",
            id: "abcdefg",
            name: "Training",
            coreArea: CORE.O,
            color: "#FFBB00",
          },
        ],
        templates: [],
      },
    ],
    id: "98765432",
    category: {
      background: "rgba(255, 187, 0, 0.1)",
      icon: "icon-lightbulb",
      description: "Innovation and Creativity",
      id: "zyxwvut",
      name: "Innovation",
      coreArea: CORE.C,
      color: "#FFBB00",
    },
  },
]; */
